import styled from 'styled-components';
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import image from '../../../images/whatsapp-sofchef-contact.png';

const CTASection = styled.section`
  width: 80%;
  max-width: 1100px;
  margin: 0 auto 6rem;
  
  @media screen and (max-width: 768px){
    width: 100%;
    max-width: auto;
    // padding: 0 1.5rem;
    margin: 0 auto 6rem;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  padding: 3rem 6rem;
  border-radius: var(--radius-lg);
  background: linear-gradient(135deg, var(--color-brand-deep), var(--color-brand));
  overflow: hidden;

  @media screen and (max-width: 768px){
    flex-direction: column;
    text-align: center;
    padding: 2.5rem 1.75rem;
    border-radius: 0;
  }
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;

  @media screen and (max-width: 768px){
    align-items: center;
  }
`;

const Title = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(1.5rem, 2.6vw, 2rem);
  font-weight: 700;
  color: var(--color-white);
  max-width: 380px;

  @media screen and (max-width: 768px) {
    max-width: none;
    font-size: 1.6rem;
  }
`;

const ButtonCta = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--color-accent);
  padding: 0.9rem 1.75rem;
  border-radius: var(--radius-sm);
  text-decoration: none;
  transition: all 0.25s ease;

  &:hover {
    background: var(--color-accent-hover);
    transform: translateY(-3px);
  }
`;

const TitleButton = styled.span`
  color: var(--color-white);
  font-family: var(--font-body);
  font-size: 1rem;
  font-weight: 700;
`;

const ImageContact = styled.img`
  width: 240px;
  flex-shrink: 0;

  @media screen and (max-width: 768px){
    width: 180px;
  }
`;

const CTA = () => {

  return (
    <CTASection id="functionalities">
      <Container>
        <TextArea>
          <Title>Quer saber mais sobre o SofChef?</Title>

          <ButtonCta
            href="https://wa.me/551632036800?text=Olá,%20gostaria%20de%20saber%20mais%20sobre%20o%20SofChef!"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Conversar pelo WhatsApp"
            data-cta-id="cta-whatsapp"
          >
            <FaWhatsapp size={22} color='#fff'/>
            <TitleButton>Entre em contato com a gente</TitleButton>
          </ButtonCta>
        </TextArea>

        <ImageContact src={image} alt="Atendimento SofChef pelo WhatsApp"/>
      </Container>
    </CTASection>
  );
};

export default CTA;
